import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  OnChanges,
} from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import { MatDialog } from '@angular/material/dialog';
import { EmailFaxDialogComponent } from '../email-fax-dialog/email-fax-dialog.component';
import { InvoiceService } from 'src/app/services/invoice/invoice.service';
import { PinPopUpComponent } from '../pin-pop-up/pin-pop-up.component';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { ErrorDialogComponent } from '../error-dialog/error-dialog.component';

@Component({
  selector: 'paginated-table',
  templateUrl: './paginated-table.component.html',
  styleUrls: ['./paginated-table.component.scss'],
})
export class PaginatedTableComponent implements OnChanges {

  isLoading = false;
  currentSortColumn: string = '';
  sortDirection: 'asc' | 'desc' | '' = '';

  sortData(column: string): void {
    if (this.currentSortColumn === column) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.currentSortColumn = column;
      this.sortDirection = 'asc';
    }

    this.dataSource.data = this.dataSource.data.sort((a, b) => {
      let valueA = a[column];
      let valueB = b[column];
      if (column === 'invoiceAmount') {
        valueA = parseFloat(valueA.replace(/[\$,]/g, ''));
        valueB = parseFloat(valueB.replace(/[\$,]/g, ''));
      }
      if (valueA < valueB) {
        return this.sortDirection === 'asc' ? -1 : 1;
      }
      if (valueA > valueB) {
        return this.sortDirection === 'asc' ? 1 : -1;
      }
      return 0;
    });
  }

  emptySearchResult:boolean=false;
  constructor(
    public dialog: MatDialog,
    private invoiceService: InvoiceService,
    private http: HttpClient
  ) {}
  displayedColumns: string[] = [
    'select',
    'customerAccount',
    'invoiceNumber',
    'invoiceDate',
    'invoiceAmount',
    'invoicePdf',
    'listPins',
  ];

  selection = new SelectionModel<any>(true, []);
  @Input() tableData: any = [];
  @Input() nextToken: string | null = null;
  @Input() message: any;

  @Output() loadMore = new EventEmitter<string>();
  @Output() loadPrevious = new EventEmitter<void>();
  callbackFunction = new EventEmitter();

  @ViewChild(MatPaginator)
  paginator!: MatPaginator;
  dataSource!: MatTableDataSource<any>;

  ngOnChanges() {
    this.emptySearchResult=false;
    this.dataSource = new MatTableDataSource(this.tableData);
    if(this.dataSource.data.length==0){
      this.emptySearchResult=true;
    }
    this.dataSource.paginator = this.paginator;
  }

  onPageChange(event: any) {
    const { pageIndex, previousPageIndex, pageSize } = event;
    if (this.paginator.pageSize == pageSize && this.nextToken) {
      this.loadMore.emit(this.nextToken);
    }
    if (pageIndex > previousPageIndex && this.nextToken) {
      this.loadMore.emit(this.nextToken);
    } else if (pageIndex < previousPageIndex) {
      this.loadPrevious.emit();
    }
  }

  goToNewSearch() {
    window.scroll({ top: 0, behavior: 'smooth' });
    this.callbackFunction.emit();
    this.tableData = [];
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected == numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  toggleAllRows() {
    this.isAllSelected()
      ? this.selection.clear()
      : this.dataSource.data.forEach((row: any) => this.selection.select(row));
  }

  openEmailFaxDialog() {
    this.dialog.open(EmailFaxDialogComponent, {
      disableClose: true,
    });
  }

  openPDF(path: string): void {
    this.isLoading = true;
    this.http.get(path, { responseType: 'blob' }).subscribe({
      next: (blob) => {
        const pdfBlob = new Blob([blob], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(pdfBlob);
        window.open(url, '_blank');
        this.isLoading = false;
      },
      error: (err) => {
        this.showErrorDialog();
        this.isLoading = false;
      }
    });
  }

  showErrorDialog(): void {
    const dialogRef = this.dialog.open(ErrorDialogComponent, {
      width: '500px',
      data: { 
        message: 'PDF_UNAVAILABLE' 
      }
    });
  
    dialogRef.afterClosed().subscribe(result => {
      console.log('closed');
    });
  }

  displayList(
    customerAccount: string,
    invoiceNumber: string,
    invoiceDate: string
  ) {
    const postData = {
      customerAccount: customerAccount,
      invoiceNumber: invoiceNumber,
      invoiceDate: invoiceDate,
    };
    this.invoiceService.getPins(postData).subscribe({
      next: (value) => {
        if (value) {
          this.dialog.open(PinPopUpComponent, {
            data: JSON.parse(value),
          });
        }
      }
    });
  }
}
